import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";

export default function SummaryPage() {
  const [summary, setSummary] = useState(null);
  const navigate = useNavigate();

  useEffect(() => {
    const data = localStorage.getItem("bookingSummary");
    if (data) {
      setSummary(JSON.parse(data));
    }
  }, []);

  if (!summary) {
    return (
      <div
        className="min-h-screen flex items-center justify-center bg-cover bg-center px-4"
        style={{ backgroundImage: `url('/bg.png')` }}
      >
        <div className="bg-white p-8 rounded shadow-xl text-center text-gray-700 font-semibold">
          No booking found. Please go back and select your ticket.
        </div>
      </div>
    );
  }

  const total = summary.tickets.reduce(
    (sum, t) => sum + t.price * t.qty,
    0
  );

  return (
    <div
      className="min-h-screen flex justify-center items-start bg-cover bg-center py-16 px-4"
      style={{ backgroundImage: `url('/bg.png')` }}
    >
      <div className="bg-white rounded-lg max-w-3xl w-full p-8 shadow-xl">
        {/* Steps */}
        <div className="flex justify-center items-center mb-10 space-x-2 text-sm md:text-base font-semibold">
          {["1. Ticket", "2. Summary", "3. Payment", "4. Done"].map((step, i) => (
            <div key={i} className="flex items-center space-x-1">
              <span
                className={`px-2 pb-1 ${
                  i === 1
                    ? "text-blue-600 border-b-2 border-blue-600"
                    : "text-gray-400"
                }`}
              >
                {step}
              </span>
              {i < 3 && <span className="text-gray-300">&#8250;</span>}
            </div>
          ))}
        </div>

        <p className="text-center text-gray-700 mb-8">
          Your booking details are displayed below. Kindly proceed to the
          payment page to complete your transaction.
        </p>

        {/* Summary Section */}
        <h2 className="font-semibold mb-3 text-lg text-gray-800">Summary</h2>
        <div className="border rounded overflow-hidden">
          <div className="grid grid-cols-2 bg-gray-50 border-b p-4 font-bold text-gray-700">
            <div>Date</div>
            <div>{new Date(summary.date).toLocaleDateString()}</div>
          </div>
          <div className="grid grid-cols-2 bg-gray-50 border-b p-4 font-bold text-gray-700">
            <div>Package</div>
            <div>{summary.package}</div>
          </div>
          <div className="p-4 space-y-2 bg-white">
            {summary.tickets
              .filter((t) => t.qty > 0)
              .map((ticket, i) => (
                <div key={i} className="text-gray-700">
                  {ticket.label} × {ticket.qty} = RM{" "}
                  {(ticket.price * ticket.qty).toFixed(2)}
                </div>
              ))}
          </div>
          <div className="grid grid-cols-2 border-t bg-gray-50 p-4 font-bold text-gray-800">
            <div>Total Payment</div>
            <div>RM {total.toFixed(2)}</div>
          </div>
        </div>

        {/* Action Buttons */}
        <div className="flex justify-end gap-4 mt-10">
          <button
            onClick={() => navigate("/")}
            className="px-8 py-3 bg-gray-300 hover:bg-gray-400 text-black rounded font-bold transition"
          >
            Back
          </button>
          <button
            onClick={() => navigate("/payment")}
            className="px-8 py-3 bg-[#3e3e52] hover:bg-[#0BBAE3] text-cyan-400 hover:text-black rounded font-bold transition"
          >
            Next
          </button>
        </div>
      </div>
    </div>
  );
}
